/**
 * The sheet every preview document is laid out on, and the margins printed
 * on it. One canonical size, scaled to whatever width the panel has, so the
 * invoice and the meal plan are the same page at the same scale — switching
 * between them changes what is on the sheet and nothing about the sheet.
 *
 * 450 x 620 is the frame's 45:62. The margins are the PDF's own A4 boxes
 * (`@page { margin: 18mm 16mm 16mm }` in `meal_plan.html`) brought to this
 * page: 210mm across 450px is 2.14px to the millimetre.
 */
export const PAGE_WIDTH = 450;
export const PAGE_HEIGHT = 620;

export const MARGIN_X = 34;
export const MARGIN_TOP = 40;
export const MARGIN_BOTTOM = 34;

/** The width the words run at, and the height they have to run down. */
export const CONTENT_WIDTH = PAGE_WIDTH - MARGIN_X * 2;
export const CONTENT_HEIGHT = PAGE_HEIGHT - MARGIN_TOP - MARGIN_BOTTOM;

/** `padding` for a sheet's content, as the three margins above. */
export const SHEET_PADDING = `${MARGIN_TOP}px ${MARGIN_X}px ${MARGIN_BOTTOM}px`;
